import React, {Component} from 'react';
import {Button} from 'reactstrap';

class SignatureDetailViewer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
  }

  render() {
    return <div>
      {this.state.visible && <Button color="link" onClick={() => this.setState({visible: false})}>
        - {this.props.hideText || "Ayrıntıları gizle"}
      </Button>}
      {!this.state.visible && <Button color="link" onClick={() => this.setState({visible: true})}>
        - {this.props.showText || "Ayrıntıları göster"}
      </Button>}
      {this.state.visible && <pre>
        {this.props.value}
      </pre>}
    </div>
  }
}

export default SignatureDetailViewer;
